// internal deps
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-core";
import {
    PaymentGroupData,
    PaymentGroupDataDef,
    PaymentGroupMeta,
    PaymentMethod,
    PaymentMethodMeta,
} from "@swiggy-private/payment-ui";

// constants
import { MORE_METHODS_PAGE_TITLES, MORE_PAYMENTS_TEXTS } from "@payment-client/constants/MorePayments";

export const getMoreMethodsPageTitle = (
    paymentGroup: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>,
): string => {
    switch (paymentGroup.groupName.toUpperCase()) {
        case VALID_PAYMENT_GROUP_TYPES.CARD:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.CARD];

        case VALID_PAYMENT_GROUP_TYPES.COD:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.COD];

        case VALID_PAYMENT_GROUP_TYPES.FOOD_CARD:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.FOOD_CARD];

        case VALID_PAYMENT_GROUP_TYPES.NETBANKING:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.NETBANKING];

        case VALID_PAYMENT_GROUP_TYPES.PAY_LATER:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.PAY_LATER];

        case VALID_PAYMENT_GROUP_TYPES.PREFERRED:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.PREFERRED];

        case VALID_PAYMENT_GROUP_TYPES.SWIGGY_INSTRUMENTS:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.SWIGGY_INSTRUMENTS];

        case VALID_PAYMENT_GROUP_TYPES.UPI:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.UPI];

        case VALID_PAYMENT_GROUP_TYPES.WALLET:
        case VALID_PAYMENT_GROUP_TYPES.WALLET_WEB:
            return MORE_METHODS_PAGE_TITLES[VALID_PAYMENT_GROUP_TYPES.WALLET];

        default:
            return MORE_PAYMENTS_TEXTS.SELECT_METHOD;
    }
};

// TODO: Might need to bring it from config
export const getThreeClickFrictionGroupOptions = (subText?: string): PaymentGroupDataDef[] => [
    {
        groupName: "threeClickPaymentOptions",
        displayName: "View more payment options",
        couponApplicable: false,
        paymentMethods: [],
        meta: {
            iconUrl: "PaymentLogos/instruments/4x/More_options",
            ctaSubtext: subText ?? "",
        },
        preferredGroup: false,
    },
];
